// extracted by mini-css-extract-plugin
module.exports = {"howPreparesSwiper":"howPreparesSwiper_howPreparesSwiper__vbZEF"};